<template>
<v-container v-if="country && country.riskData && country.riskData.length>0 " :class="{'isMobile': isMobile}">
    <v-row class="countryNameBar__holder ma-0">
        <country-name-bar :countryName="country.country_name" />
    </v-row>
    <v-row class="widgetTitle__holder mb-0" :class="{'mt-15' : !isMobile}">
            <span class="widgetTitle mb-0">STAR rating</span>
    </v-row>
    <v-row class="contentRow" >
        <v-col md="6" cols="12" class="pa-0 ma-0">
            <v-row class="d-flex">
                <v-col md="auto" cols="6" class="pa-0 ma-0">
                    
					<span :class="'star_score_text _' + country.riskData[0].star" :style="'color:' + country.riskCategoryObject.color">
                        {{ formatRiskCategory(country.riskData[0].star) }}
                    </span>

					<span class="movementIconsContainer">
						<v-icon v-tooltip="tooltipData()" class="lineItem movementInfoIcon">mdi-information-outline</v-icon>

						<v-icon class="lineItem movementArrowIcon" v-if="country.riskData[0].difference < 0">mdi-arrow-up</v-icon>
						<v-icon class="lineItem movementArrowIcon" v-if="country.riskData[0].difference > 0">mdi-arrow-down</v-icon>
						
						<span v-if="country.riskData[0].difference !== 0" class="lineItem movementDirectionText" :style="'color:' + getHexColor(country.riskData[0].star_previous_quarter)">
							{{ country.riskData[0].star_previous_quarter }}
						</span>
					</span>
					
                </v-col>

                <v-col v-if="!isMobile" cols="6" md="6" class="ml-4">
                    <v-row class="riskTitleTextDesktop riskTitleText pt-4">
                        <v-col md="12" cols="12">
                            <span class="firstLine" >
                                <span class="firstLine" >
                                {{ correctRiskWording(country.riskCategoryObject.risk)[0] }}
                                </span>
                            </span>
                        <span class="secondLine">
                                {{ correctRiskWording(country.riskCategoryObject.risk)[1] }}
                            </span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>

        <v-row class="riskTitleTextMobile riskTitleText">
              <v-col md="12" cols="12">
                  <span class="firstLine">
                      {{ correctRiskWording(country.riskCategoryObject.risk)[0] }} 
                  </span>
                  <span class="secondLine">
                      {{ correctRiskWording(country.riskCategoryObject.risk)[1] }}
                  </span>
              </v-col>
          </v-row>

        <v-col md="6" cols="12" class="starDescriptionText pa-0 ma-0">
            <v-row>
                <v-col cols="12">
                    <p class="mt-0">
                       {{ countryRiskParagraph }}
                    </p>
                </v-col>
            </v-row>
        </v-col>
        <!-- <v-row> -->
              <!-- <span class="sourcesText mt-12">Sources: Atradius Economic Research</span> -->
        <!-- </v-row> -->
    </v-row>
</v-container>
<!-- <v-container v-else>
        <v-row>
            <v-col cols="12">
                <span class="">No data available</span>
            </v-col>
        </v-row>
    </v-container> -->
</template>

  
  
<script lang="ts">
import {
    defineComponent,
    ref,
    computed,
    watch,
    onMounted
} from 'vue';
import store from '@/store';

import {
    Service as CountryService
} from '@/services/countryService';

import {
    riskToNumeric, getRiskCategory, riskMapColours
} from '@/services/dataHandlerService';

let activeCountry: any = null;
// let newTooltipText = 'sssssss';

function calculateTooltipData(){
            const tooltipData = store.getters['displayStoreData/toolTipData'];
            console.log('activeCountry', activeCountry);
            try {
                if(activeCountry.riskData[0].star_previous_quarter != activeCountry.riskData[0].star && tooltipData ){
                    const tooltipText = tooltipData.country_risk_modal.different_risk_star_values.text;
                    // this.currentTooltipText = tooltipText;
                    return tooltipText;
                }else{
                    const tooltipText = tooltipData.country_risk_modal.same_risk_star_values.text;
                    // this.currentTooltipText = tooltipText;
                    return tooltipText;
                }
                    
            } catch (error) {
                // 
            }
            
            return "The Arrow indicates movement up/down and by what amount out of 10.";
        }
export default defineComponent({
    name: 'RiskComponent',
    methods:{
        getTooltipData(){
            return this.currentTooltipText = calculateTooltipData();
            
        },
        getHexColor(risk: number) {
            const numericRisk = riskToNumeric(risk);
            const riskCategory = getRiskCategory(numericRisk);
            const hexColor = riskMapColours[riskCategory - 1];            
            return hexColor.color;
        }
    },
    mounted(){
        this.currentTooltipText = this.getTooltipData();
    },
    data() {
        return {
            currentTooltipText: ''
        }
    },
    setup() {
        const isMobile = window.innerWidth <= 1024;

        // Define reactive state
        const movementDirection = ref('stable');
        const movementValue = ref(0);
        
        const country = computed({
            get() {
                let country =  store.getters['countryStoreData/selectedCountry'];
                activeCountry = country;
                return country;
            },
            set(value: any) {
                store.dispatch('stateStoreData/setCountry', value);
            }
        });

        const calculateMovements = () => {
            if (!country.value) {
                return
            }
          
            const countryObject = CountryService.getCountryKeyData(country.value.country_code);


            const starString = country.value.riskData[0].star;
            const movementValue = CountryService.getMovementValue(country);
            const movementDirection = CountryService.getMovementDirection(country);
        }

        // Define a method to format the risk category
        const formatRiskCategory = (value: number): string => {
            return value.toString();
        };

        // Define a method to correct the risk wording
        const correctRiskWording = (wording: string): string[] => {
            // let newWording = wording.toLowerCase().replace(' risk', ' country risk');
            let newWording = wording.toLowerCase() + ' Risk';
            const wordArray: string[] = [];
            const allWords = newWording.split(' ');
            wordArray.push(allWords[0]);
            let secondLine = '';
            for (let i = 1; i < allWords.length; i++) {
                secondLine += allWords[i] + ' ';
            }
            wordArray.push(secondLine.trim());
            return wordArray;
        };

        // Watch for changes in country data
        watch(
            country,
            (val: any) => {
                // getTooltipData();
            }, {
                immediate: true,
                deep: true
            }
        );

        onMounted(() => {
            // calculateMovements();
            
        });

        const tooltipData = () =>{

            return calculateTooltipData();
        }

        const allTooltipData = store.getters['displayStoreData/toolTipData'];
        const countryRiskParagraph = allTooltipData.country_risk_paragraph.text ||  'The STAR rating runs on a scale from 1 to 10, where 1 represents the lowest risk and 10 the highest risk. Starting from the most benign part of the quality spectrum, these categories range from ‘Low Risk’ to ‘Very High Risk.';



        return {
            movementDirection,
            movementValue,
            country,
            formatRiskCategory,
            correctRiskWording,
            isMobile,
            tooltipData,
            countryRiskParagraph
        };
    }
});
</script>
  
  
<style scoped>
.widgetTitle {
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    font-family: 'GCO Sans', sans-serif;
}

.star_score_text {
    font-size: 200px;
    font-weight: 400;
    line-height: 180px;
    letter-spacing: -3%;
    font-family: 'GCO', sans-serif;
}

.riskTitleTextDesktop{
    padding-top: 0;
    margin-top: 0;
}

.riskTitleText {
    font-size: 36px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    text-align: left;
    font-family: 'GCO', sans-serif;
}

.riskTitleText .firstLine {
    display: block;
    line-height: 2;
    text-transform: capitalize;
    color: #333333;
}

.riskTitleText .secondLine {
    display: block;
    /* text-transform: lowercase; Left this here to show it's been changed multiple times beofre */
    text-transform: capitalize;
    color: #333333;
}

.movementDirectionText {
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: -2%;
    font-family: 'GCO', sans-serif;
    position: relative;
    top: 3px;
    margin: 0 3px;
}

.movementIconsContainer {
	position: absolute;
	margin-left: 25px;
	margin-top: 5px;
}

.movementInfoIcon {
    font-size: 20px;
    font-weight: 100;
    line-height: 28px;
    letter-spacing: -2%;
    font-family: 'GCO Sans', sans-serif;
	margin-right: 10px;
	margin-top: 2px;
}



.movementDataRow {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.starDescriptionText {
    /* align to bottom of div */
    display: flex;
    align-items: flex-end;  
    font-size: 20px;  
    font-weight: 400;
    line-height: 28px;
    color: #3C424C;
}

.sourcesText {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #606A76;
  padding-left: 12px;
  height: 5%;
  font-family: 'GCO Sans', sans-serif;
}

/*Mobile using media queries*/
@media (max-width: 1100px) {
    .star_score_text {
        font-size: 140px;
        line-height: 130px;
    }

  .riskTitleText{
    display: none;
  }
  
  .riskTitleTextMobile{
    display: block;
    font-size: 36px;
    line-height: 40px;
    padding-top: 0.4em
  
  }

  .riskTitleTextMobile .firstLine,
  .riskTitleTextMobile .secondLine{
    display: inline-block !important;
    margin-right: 10px;
  }

  .widgetTitle{
    margin-top: 1em;
    margin-bottom: 1em;
    display: block;
  }

  .movementDirectionText {
    margin-left: -2px;
    margin-right: 8px;
  }

  .starDescriptionText {
    font-size: 16px;
    line-height: 24px;
  }

}

/* Desktop using media queries */
@media (min-width: 1024px) {
    .riskTitleTextMobile {
      display: none;
    }    
}

/* IPad star_score_text */
@media (min-width: 1180px) and (max-width: 1200px) {

    .star_score_text {
        font-size: 177px;
    }

    /* .riskTitleText .firstLine, .riskTitleText .secondLine {
        line-height: 1.4;
    } */
}
</style>

